import { defineComponent } from "vue";

/**
 * 渲染 `Address` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const Address = defineComponent({
	name: "Address",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
				<path d="M501.76 30.72C337.92 30.72 204.8 163.84 204.8 330.24c0 163.84 161.28 371.2 299.52 540.16 135.68-171.52 299.52-373.76 299.52-540.16-2.56-166.4-135.68-299.52-302.08-299.52z m0 496.64c-110.08 0-197.12-89.6-197.12-197.12 0-110.08 89.6-197.12 197.12-197.12 110.08 0 197.12 89.6 197.12 197.12 2.56 110.08-87.04 197.12-197.12 197.12z m0 0" />
				<path d="M389.12 330.24c0 30.72 12.8 58.88 33.28 79.36 20.48 20.48 51.2 33.28 79.36 33.28 30.72 0 58.88-12.8 79.36-33.28 20.48-20.48 33.28-51.2 33.28-79.36 0-30.72-12.8-58.88-33.28-79.36-20.48-20.48-51.2-33.28-79.36-33.28-30.72 0-58.88 12.8-79.36 33.28-20.48 20.48-33.28 48.64-33.28 79.36z m0 0" />
				<path d="M504.32 1000.96c-192 0-386.56-61.44-386.56-176.64 0-64 64-117.76 176.64-151.04 20.48-5.12 40.96 5.12 46.08 25.6 5.12 20.48-5.12 40.96-25.6 46.08-84.48 23.04-122.88 56.32-122.88 79.36 0 40.96 122.88 102.4 314.88 102.4 192 0 314.88-61.44 314.88-102.4 0-23.04-46.08-58.88-130.56-81.92-20.48-5.12-30.72-25.6-25.6-46.08 5.12-20.48 25.6-30.72 46.08-25.6 117.76 30.72 186.88 87.04 186.88 153.6-7.68 115.2-202.24 176.64-394.24 176.64z m0 0" />
			</svg>
		);
	},
});

export default Address;
